import { render, staticRenderFns } from "./Distributor.vue?vue&type=template&id=56b48e9f&scoped=true&"
import script from "./Distributor.vue?vue&type=script&lang=js&"
export * from "./Distributor.vue?vue&type=script&lang=js&"
import style0 from "./Distributor.vue?vue&type=style&index=0&id=56b48e9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b48e9f",
  null
  
)

export default component.exports